import { TimerType } from '../web-workers/timer.worker';
import { modifiedSetTimeout, modifiedSetInterval } from '../utilities/ZoneUtils';

export interface ITimerHandler {
  setTimeout(durationMs: number): NodeJS.Timer;
  setInterval(durationMs: number): NodeJS.Timer;
  clearTimeout(id: NodeJS.Timer): void;
  clearInterval(id: NodeJS.Timer): void;
}

export class NativeTimerFallback implements ITimerHandler {
  constructor(private onTimerFired: (type: TimerType, id: NodeJS.Timer) => void) {}

  setTimeout(durationMs: number): NodeJS.Timer {
    const id = modifiedSetTimeout(() => this.onTimerFired(TimerType.timeout, id), durationMs, true);
    return id;
  }

  setInterval(durationMs: number): NodeJS.Timer {
    const id = modifiedSetInterval(
      () => this.onTimerFired(TimerType.interval, id),
      durationMs,
      true,
    );
    return id;
  }

  clearTimeout(id: NodeJS.Timer): void {
    clearTimeout(id);
  }

  clearInterval(id: NodeJS.Timer): void {
    clearInterval(id);
  }
}
